import { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import CanvasFeather from './components/CanvasFeather';
import FloatQRCode from '@/src/components/FloatQRCode';
import NavBar from './components/NavBar';
import Top from './components/SlideTop';
import World from './components/SlideWorld';
import Character from './components/SlideCharacter';
import About from './components/SlideAbout';
import Record from './components/SlideRecord';
import Footer from '@/src/components/Footer';

import styles from './style.module.scss';

const Secondary = ({
  page,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const swiperRef = useRef(null);

  const downloadData = useMemo(() => {
    return {
      dCode: page?.dCode?.[0].value || '',
      dIos: page?.dIos?.[0].value || '',
      dAndroid: page?.dAndroid[0].value || '',
    };
  }, [page]);

  // get swiper instance
  const onSwiper = useCallback((swiper) => {
    swiperRef.current = swiper;
  }, []);

  // when swiper change, update active nav
  const onSlideChange = useCallback((swiper) => {
    let { realIndex: index } = swiper;
    index = Math.min(index, 4);
    setSelectedIndex(index);
  }, [selectedIndex]);

  // change swiper slide when navbar clicked
  useEffect(() => {
    swiperRef.current.slideTo(selectedIndex);
  }, [selectedIndex]);

  return (
    <div className={styles.container}>
      <NavBar
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        downloadData={downloadData}
      />
      <CanvasFeather />
      <FloatQRCode isSecondary url={downloadData.dCode} />
      <Swiper
        speed={600}
        direction="vertical"
        className={styles.swiper}
        modules={[Mousewheel]}
        mousewheel
        slidesPerView="auto"
        allowTouchMove={false}
        onSwiper={onSwiper}
        onSlideChange={onSlideChange}
        observeParents
        observer
      >
        <SwiperSlide>
          <Top active={selectedIndex === 0} />
        </SwiperSlide>
        <SwiperSlide>
          <World />
        </SwiperSlide>
        <SwiperSlide>
          <Character active={selectedIndex === 2} />
        </SwiperSlide>
        <SwiperSlide>
          <About />
        </SwiperSlide>
        {new Array(5).fill('').map((_, index) => (
          <SwiperSlide key={index}>
            <Record index={index} />
          </SwiperSlide>
        ))}
        <Record />
        <SwiperSlide style={{ height: '27.3vw', overflow: 'visible' }}>
          <Footer isSecondary />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Secondary;
